import { render, staticRenderFns } from "./ReviewPayoutModal.vue?vue&type=template&id=b4cf178a&scoped=true&"
import script from "./ReviewPayoutModal.vue?vue&type=script&lang=js&"
export * from "./ReviewPayoutModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPayoutModal.vue?vue&type=style&index=0&id=b4cf178a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf178a",
  null
  
)

export default component.exports